import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import AwardsList from "./AwardsListe";



function AwardsListMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <AwardsList/>
            </BasicCard>
        </>
    )
}
export default AwardsListMain;